import { render, staticRenderFns } from "./RoutesForm.vue?vue&type=template&id=2c476732&scoped=true&"
import script from "./RoutesForm.vue?vue&type=script&lang=js&"
export * from "./RoutesForm.vue?vue&type=script&lang=js&"
import style0 from "./RoutesForm.vue?vue&type=style&index=0&id=2c476732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c476732",
  null
  
)

export default component.exports